'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UlNoBullet = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-size:14px;\n  font-family:"Open Sans", arial;\n  color:', ';\n  list-style:disc;\n  padding:0;\n  margin-left:1.4em;\n\n  li{\n    margin-bottom:0.3em;\n\n    a > svg{\n      position:relative;\n      top:-0.1em;\n    }\n  }\n'], ['\n  font-size:14px;\n  font-family:"Open Sans", arial;\n  color:', ';\n  list-style:disc;\n  padding:0;\n  margin-left:1.4em;\n\n  li{\n    margin-bottom:0.3em;\n\n    a > svg{\n      position:relative;\n      top:-0.1em;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tlist-style:none !important;\n\tmargin-left:0;\n\tpadding:0;\n'], ['\n\tlist-style:none !important;\n\tmargin-left:0;\n\tpadding:0;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iaReact = require('ia.react.colorlist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Ul = _styledComponents2.default.ul(_templateObject, _iaReact.COLORS.grey5);

var UlNoBullet = exports.UlNoBullet = (0, _styledComponents2.default)(Ul)(_templateObject2);

exports.default = Ul;